import { render } from "./ImprintPage.vue?vue&type=template&id=a000d2e0"
import script from "./ImprintPage.vue?vue&type=script&lang=js"
export * from "./ImprintPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__